module.exports = __webpack_public_path__ + "img/1588597318.baaefddf.jpg";